module.exports = __webpack_public_path__ + "723fcd0b5377813840646b167726f074.jpg";